import { LatLongParamInput } from '../../../constants/search';
import {
  makeUnauthenticatedNetworkRequest,
  SignalProp,
  unwrapNetworkResponse,
} from '../../../services/api';

export interface GetLatLonReqType {
  query: LatLongParamInput;
}

interface Coordinates {
  longitude: number;
  latitude: number;
}

interface BoundingBox {
  [index: number]: number;
}

interface ContextItem {
  mapbox_id: string;
  name: string;
  wikidata_id?: string;
  region_code?: string;
  region_code_full?: string;
  country_code?: string;
  country_code_alpha_3?: string;
}

interface Context {
  district?: ContextItem;
  region?: ContextItem;
  country?: ContextItem;
  place?: ContextItem;
  neighborhood?: ContextItem;
  postcode?: ContextItem;
}

interface Properties {
  mapbox_id: string;
  feature_type: string;
  full_address: string;
  name: string;
  name_preferred: string;
  coordinates: Coordinates;
  place_formatted: string;
  bbox: BoundingBox;
  context: Context;
}

interface Geometry {
  type: string;
  coordinates: [number, number];
}

interface Feature {
  type: string;
  id: string;
  geometry: Geometry;
  properties: Properties;
}

export interface GetLatLonResType {
  type: string;
  features: Feature[];
  attribution: string;
}

const locationBaseUrl = import.meta.env.VITE_PUBLIC_API_GATEWAY_URL as string;
export const getLatLonUrl = `/mapbox/lat-lon`;

export async function getLatLon({
  signal,
  query,
}: SignalProp & GetLatLonReqType) {
  const keysOfInterest = ['state', 'city', 'county', 'zip'];

  const interestParamString = Object.entries(query)
    .filter(
      ([key, value]) =>
        keysOfInterest.includes(key) && value !== undefined && value !== null
    )
    .map(([, value]) => value)
    .join('%20');

  const relativeUrl =
    `${getLatLonUrl}?properties=${interestParamString}` as const;

  const res = await makeUnauthenticatedNetworkRequest({
    method: 'GET',
    baseUrl: locationBaseUrl,
    relativeUrl,
    signal,
  });

  const data = await unwrapNetworkResponse<GetLatLonResType>(res);
  const longitude: number | undefined =
    data?.features?.[0]?.geometry?.coordinates?.[0];
  const latitude: number | undefined =
    data?.features?.[0]?.geometry?.coordinates?.[1];

  return { latitude, longitude };
}
